const CARDS_DATA = [
  {
    title: '长安风云录',
    tag: '古装权谋',
    rating: '9.5',
    desc: '大唐盛世下的宫廷权谋与家国情仇，全60集完整版一口气追完。',
    img: 'https://readdy.ai/api/search-image?query=Professional%20poster%20style%20image%20of%20a%20Chinese%20historical%20costume%20drama%2C%20elegant%20ancient%20palace%20scenery%20with%20cherry%20blossoms%2C%20traditional%20Chinese%20architecture%20in%20soft%20golden%20sunset%20light%2C%20warm%20orange%20and%20crimson%20tones%2C%20cinematic%20movie%20poster%20composition%2C%20rich%20textures%2C%20stylized%20artistic%20rendering%2C%20clean%20simple%20background%20with%20dramatic%20lighting&width=400&height=560&seq=card-drama-01&orientation=portrait',
    imgAlt: '长安风云录 - 古装权谋剧海报',
  },
  {
    title: '都市夜归人',
    tag: '都市情感',
    rating: '9.2',
    desc: '繁华都市中三个年轻人的梦想与爱情，全42集温情收官。',
    img: 'https://readdy.ai/api/search-image?query=Professional%20poster%20style%20image%20of%20a%20modern%20urban%20drama%2C%20sleek%20city%20skyline%20at%20twilight%20with%20warm%20ambient%20lights%2C%20contemporary%20office%20buildings%20with%20glass%20facades%20reflecting%20golden%20hour%20light%2C%20sophisticated%20metropolitan%20atmosphere%2C%20warm%20amber%20and%20rose%20gold%20tones%2C%20cinematic%20poster%20composition&width=400&height=560&seq=card-drama-02&orientation=portrait',
    imgAlt: '都市夜归人 - 都市情感剧海报',
  },
  {
    title: '暗夜追踪',
    tag: '悬疑刑侦',
    rating: '9.4',
    desc: '连环案件背后的惊天秘密，全36集高能反转不断。',
    img: 'https://readdy.ai/api/search-image?query=Professional%20poster%20style%20image%20of%20a%20mystery%20thriller%20drama%2C%20moody%20atmospheric%20scene%20with%20dramatic%20shadows%20and%20warm%20amber%20light%20filtering%20through%20venetian%20blinds%2C%20noir%20inspired%20aesthetic%20with%20deep%20shadows%20and%20golden%20highlights%2C%20suspenseful%20cinematic%20composition&width=400&height=560&seq=card-drama-03&orientation=portrait',
    imgAlt: '暗夜追踪 - 悬疑刑侦剧海报',
  },
  {
    title: '遇见你的季节',
    tag: '浪漫爱情',
    rating: '9.1',
    desc: '从校园到婚纱的十年爱情长跑，全32集甜蜜暴击。',
    img: 'https://readdy.ai/api/search-image?query=Professional%20poster%20style%20image%20of%20a%20romantic%20drama%2C%20soft%20dreamy%20scene%20with%20warm%20golden%20sunlight%20streaming%20through%20autumn%20trees%2C%20couple%20silhouettes%20in%20gentle%20backlight%2C%20romantic%20warm%20amber%20and%20peach%20tones%2C%20cinematic%20poster%20composition%2C%20ethereal%20atmospheric%20rendering&width=400&height=560&seq=card-drama-04&orientation=portrait',
    imgAlt: '遇见你的季节 - 浪漫爱情剧海报',
  },
  {
    title: '家的方向',
    tag: '家庭伦理',
    rating: '9.3',
    desc: '三代同堂的欢笑与泪水，全48集温暖人心之作。',
    img: 'https://readdy.ai/api/search-image?query=Professional%20poster%20style%20image%20of%20a%20family%20drama%2C%20warm%20cozy%20living%20room%20scene%20with%20soft%20golden%20ambient%20lighting%2C%20comfortable%20furniture%20with%20warm%20textiles%2C%20gentle%20sunlight%20through%20windows%2C%20homely%20intimate%20atmosphere%2C%20warm%20ochre%20and%20cream%20tones%2C%20cinematic%20composition&width=400&height=560&seq=card-drama-05&orientation=portrait',
    imgAlt: '家的方向 - 家庭伦理剧海报',
  },
];

const FAQ_DATA = [
  { q: '桔子影院需要注册会员才能观看吗？', a: '不需要。本站所有电视剧全集完整剧集均免费在线观看，无需注册、无需登录，打开即可畅享高清追剧体验。' },
  { q: '剧集更新速度如何？能否第一时间看到最新集？', a: '我们与播出平台保持同步更新，每日更新10部以上热播剧集。大结局上线后第一时间收录，让你追剧不等待。' },
  { q: '支持哪些设备观看？手机可以看吗？', a: '全面支持电脑、平板和手机浏览器访问，自适应不同屏幕尺寸。无论在家还是通勤路上，随时随地打开浏览器即可追剧。' },
  { q: '画质怎么样？有高清资源吗？', a: '所有剧集均提供1080P高清画质，采用优化编码技术确保画面清晰流畅，同时兼顾加载速度，让你享受影院级观影体验。' },
  { q: '海外剧有中文字幕吗？', a: '海外剧全集均配有高质量中文字幕，由专业团队精心译制，确保翻译准确、语句通顺，让你无障碍畅享全球好剧。' },
  { q: '如果遇到播放问题该怎么办？', a: '如遇播放卡顿或加载问题，可尝试切换网络环境或刷新页面。如问题持续存在，欢迎通过本站联系方式向我们反馈，我们会尽快优化。' },
];

const INDEX_DATA = [
  { title: '古装剧场', count: '328部', desc: '仙侠、宫斗、权谋、武侠，经典与新作一网打尽', icon: 'ri-sword-line' },
  { title: '都市情感', count: '256部', desc: '职场、爱情、家庭，都市生活的百味人生', icon: 'ri-building-line' },
  { title: '悬疑探案', count: '189部', desc: '刑侦、推理、谍战，烧脑剧集高能不断', icon: 'ri-search-eye-line' },
  { title: '青春偶像', count: '142部', desc: '校园、甜宠、成长，青春最美的样子', icon: 'ri-heart-line' },
  { title: '海外精选', count: '415部', desc: '美剧、韩剧、日剧、泰剧，全球好剧尽在掌握', icon: 'ri-global-line' },
  { title: '年代传奇', count: '97部', desc: '民国、战争、家族，大时代下的小人物故事', icon: 'ri-history-line' },
  { title: '喜剧乐园', count: '163部', desc: '情景喜剧、轻喜爱情，欢笑中感受生活温度', icon: 'ri-emotion-laugh-line' },
];

export function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-50 scroll-mt-16">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
          移动追剧
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          随时随地，追剧不停歇
        </p>
        <div className="max-w-2xl mx-auto bg-gradient-to-br from-primary-500 via-primary-600 to-accent-500 rounded-2xl p-8 md:p-12 text-center">
          <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-background-50/20 flex items-center justify-center">
            <i className="ri-smartphone-line text-3xl text-background-50"></i>
          </div>
          <h3 className="font-heading text-xl md:text-2xl font-bold text-background-50 mb-3">
            桔子影院移动端
          </h3>
          <p className="text-sm text-background-50/80 mb-6 max-w-md mx-auto leading-relaxed">
            适配手机与平板浏览器，无需下载APP，打开浏览器输入网址即可畅享全网热播电视剧全集完整剧集。支持横竖屏切换，追剧体验流畅舒适。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a href="#cards" className="w-full sm:w-auto px-6 py-2.5 rounded-full bg-background-50 text-primary-600 font-semibold text-sm whitespace-nowrap hover:bg-background-50/90 transition-colors cursor-pointer">
              立即追剧
            </a>
            <a href="#faq" className="w-full sm:w-auto px-6 py-2.5 rounded-full border border-background-50/40 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-background-50/10 transition-colors cursor-pointer">
              了解更多
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-100 scroll-mt-16">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
          热播精选
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          全网热播剧集一网打尽，完整剧集免费畅享
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {CARDS_DATA.map((card) => (
            <article key={card.title} className="group cursor-pointer">
              <div className="relative overflow-hidden rounded-xl mb-3 aspect-[2/3] bg-background-200">
                <img
                  src={card.img}
                  alt={card.imgAlt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
                <div className="absolute top-2 right-2">
                  <span className="px-1.5 py-0.5 rounded-md bg-background-50/90 text-primary-600 text-xs font-bold whitespace-nowrap">
                    {card.rating}
                  </span>
                </div>
              </div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {card.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                {card.desc}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-50 scroll-mt-16">
      <div className="max-w-3xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          关于桔子影院的常见疑问解答
        </p>
        <div className="space-y-3">
          {FAQ_DATA.map((item, i) => (
            <details key={i} className="group bg-background-100 rounded-xl p-5 md:p-6 cursor-pointer transition-colors hover:bg-background-200/70">
              <summary className="flex items-center justify-between list-none">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {item.q}
                </h3>
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 flex items-center justify-center group-open:rotate-45 transition-transform duration-200">
                  <i className="ri-add-line text-primary-600 text-sm"></i>
                </span>
              </summary>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                {item.a}
              </p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

export function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-100 scroll-mt-16">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
          剧集专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          按题材分类探索，找到你的下一部好剧
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {INDEX_DATA.map((item) => (
            <a
              key={item.title}
              href="#cards"
              className="group bg-background-50 rounded-xl p-5 md:p-6 hover:bg-primary-50 transition-colors cursor-pointer border border-background-200/60 hover:border-primary-200"
            >
              <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-lg text-accent-600`}></i>
              </div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-1 whitespace-nowrap group-hover:text-primary-700 transition-colors">
                {item.title}
              </h3>
              <span className="inline-block text-xs text-primary-600 font-medium mb-2 whitespace-nowrap">{item.count}</span>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                {item.desc}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}